import Cookies from "js-cookie";

class BasketCount extends HTMLElement {
    constructor() {
        super();

        this.el = this;
        this.counter = this.querySelector("[basket-item-count]");

        this.handleBasketCount();
    }

    connectedCallback() {
        document.addEventListener("basketCount", (event) =>
            this.handleBasketCount(event),
        );
    }

    handleBasketCount(event) {
        // The event and cookie are both set by the pathway in router.js
        // They are updated every time the basket endpoint is called

        let items = null;
        if (event?.detail?.count) {
            items = event.detail.count;
        } else {
            const cookie = Cookies.get("basket_count");
            if (cookie) {
                items = cookie;
            }
        }

        // If no items hide element
        if (!items) {
            this.el.style.display = "none";
            return;
        }

        // If items add number to counter
        this.counter.innerHTML = items;

        // If items is 0 hide element
        if (items == 0) {
            this.el.style.display = "none";
            return;
        }

        // If items is more than 0 show element
        this.el.style.display = "";
    }
}

customElements.define("basket-count", BasketCount);
